export const CANANA_COUNTRY_CODE = '1';
